import classNames from 'classnames';
import { Paragraph, RichText } from 'ui/components';
import { useState } from 'react';
import styles from './AccordionItem.module.scss';
import { generateId } from 'helpers/id';
import { ReactComponent as ChevronUp } from 'ui/icons/icon-chevron-down-big.svg';

export interface AccordionItemDataProps {
	openByDefault?: boolean;
	title: string;
	anchor?: string;
	htmlContent: string;
}

export interface AccordionItemProps extends AccordionItemDataProps {
	headingLevel?: 'h2' | 'h3' | 'h4' | 'h5';
	textColor?: string;
	open: boolean;
	onToggle: () => void;
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
	title,
	htmlContent,
	anchor,
	open,
	onToggle,
	headingLevel = 'h2',
	textColor
}) => {
	const [id] = useState(() => generateId());

	const triggerId = anchor || `accordion-trigger-${id}`;
	const panelId = `accordion-panel-${id}`;

	const HeadingTag = headingLevel;

	return (
		<div
			className={styles.AccordionItem}
			style={
				{
					'--item-text-color': textColor
				} as React.CSSProperties
			}
		>
			<HeadingTag className={styles.AccordionItem_heading}>
				<button
					type="button"
					id={triggerId}
					onClick={onToggle}
					className={styles.AccordionItem_triggerContainer}
					aria-expanded={open}
					aria-controls={panelId}
				>
					<Paragraph
						style="lg"
						className={styles.AccordionItem_title}
					>
						{title}
					</Paragraph>

					<div className={styles.AccordionItem_iconContainer}>
						<div>
							<ChevronUp
								className={classNames(
									styles.AccordionItem_icon,
									{
										[styles.AccordionItem_icon___isOpen]:
											open
									}
								)}
							/>
						</div>
					</div>
				</button>
			</HeadingTag>

			<div
				id={panelId}
				role="region"
				aria-labelledby={triggerId}
				className={styles.AccordionItem_panel}
				hidden={!open}
			>
				<RichText
					content={htmlContent}
					className={styles.AccordionItem_content}
				/>
			</div>
		</div>
	);
};